module.exports = __webpack_public_path__ + "static/imacGlare-6e58b705a8ca1cdd00a05425517ae047.png";